import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { clsx as cx } from 'clsx';
import * as styles from './styles.module.css';
export function IconButton(props) {
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    type: "button",
    className: cx(props.className, styles['button'])
  }));
}